import { render, staticRenderFns } from "./NotificationsListItem.vue?vue&type=template&id=06b565ee&scoped=true"
import script from "./NotificationsListItem.vue?vue&type=script&lang=js"
export * from "./NotificationsListItem.vue?vue&type=script&lang=js"
import style0 from "./NotificationsListItem.vue?vue&type=style&index=0&id=06b565ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b565ee",
  null
  
)

export default component.exports